module.exports = __webpack_public_path__ + "static/media/Embedded Cryptography.3e345ca3.png";